// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-popover ion-list {
  padding: 5px 0;
  margin: 0;
  border-radius: 10px;
  border: 2px var(--ion-color-secondary) solid;
  width: 200px;
  align-self: end;
}
.menu-popover ion-icon {
  font-size: 17px;
  margin: 0;
  padding: 0;
}
.menu-popover ion-label {
  padding: 0;
  margin: 0;
  color: var(--ion-color-secondary);
  font-size: 12px;
}
.menu-popover ion-item {
  padding: 0 20px;
  margin: 0;
  line-height: 40px;
}
.menu-popover ion-item::part(native) {
  min-height: 30px;
  font-size: 12px;
}
.menu-popover ion-item:last-child {
  --border-width: 0 0 0 0 !important;
  --inner-border-width: 0 0 0 0 !important;
}

@media only screen and (min-width: 460px) {
  ion-content {
    --width: 460px;
  }
}
@media only screen and (min-width: 1450px) {
  ion-content {
    --width: 620px;
  }
}

@media only screen and (min-width: 460px) {
  .swiper {
    height: 100%;
    width: 100%;
    background: var(--planeed-blue);
  }
  .swiper img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
}
@media only screen and (max-width: 460px) {
  .swiper {
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    width: 100%;
  }
  .swiper img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}
.swiper-button-disabled {
  display: none;
  opacity: 0;
  pointer-events: none;
}

div {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  z-index: 1;
}

.name-row {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: left;
  padding: 0;
}
.name-row .profile-photo {
  height: 28px;
  width: 28px;
  border-radius: 50%;
  border: 2px solid var(--planeed-color-white);
  filter: drop-shadow(1px 1px 2px rgba(37, 37, 37, 0.3));
  padding: 1px;
  background: white;
}
.name-row .organization-photo {
  height: 28px;
  width: 28px;
  border-radius: 8px;
  border: 2px solid var(--planeed-color-white);
}
.name-row span {
  padding-left: 5px;
  color: var(--planeed-color-white);
  text-shadow: 1px 1px 1px #888888;
  filter: drop-shadow(1px 1px 2px rgba(37, 37, 37, 0.3));
}
.name-row .createdAt {
  margin-top: 5px;
  margin-left: 0;
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  color: var(--planeed-color-white);
  text-shadow: 1px 1px 1px #888888;
}

.moods-row {
  filter: drop-shadow(1px 1px 2px rgba(37, 37, 37, 0.3));
  text-align: left;
  padding-right: 20px;
  padding-bottom: 0;
}
.moods-row .moods {
  margin-left: auto;
  margin-right: 0;
  width: fit-content;
}
.moods-row .moods ion-icon {
  height: 24px;
  width: 24px;
  fill: #ffffff;
  filter: drop-shadow(1px 1px 1px #c2c2c2);
}
.moods-row .moods ion-button {
  margin: 0;
  --padding-start: 0px;
  --padding-end: 0px;
}

#momentsNav {
  position: relative;
  z-index: 999;
}
#momentsNav .takeMoment {
  margin-left: auto;
  width: 100%;
}
#momentsNav .takeMoment .takePhotoIconPos {
  text-align: right;
  margin-right: 25px;
}
#momentsNav .takeMoment ion-icon {
  height: 25px;
  width: 30px;
  fill: #ffffff;
}
#momentsNav .takeMoment ion-icon:hover {
  cursor: pointer;
}

.moodPopover {
  --width: 46px;
  background-color: transparent;
  align-items: center;
  padding-bottom: 25px;
  --offset-y: -15px;
}
@media only screen and (min-width: 460px) {
  .moodPopover {
    --width: 60px;
  }
}
.moodPopover .popRow {
  margin: 5px 3px;
}
.moodPopover .popRow .moodButtonContent {
  width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media only screen and (min-width: 460px) {
  .moodPopover .popRow .moodButtonContent {
    width: 60px;
  }
}
.moodPopover .popRow .moodButtonContent .moodPopIcon {
  height: 18px;
  width: 18px;
}
@media only screen and (min-width: 460px) {
  .moodPopover .popRow .moodButtonContent .moodPopIcon {
    height: 24px;
    width: 24px;
  }
}
.moodPopover .popRow .moodButtonContent .moodPopIcon:hover {
  cursor: pointer;
}
.moodPopover .popRow .moodButtonContent .moodName {
  margin-top: 2px;
  margin-bottom: 2px;
  font-size: 6px;
  color: var(--ion-color-secondary);
}
@media only screen and (min-width: 460px) {
  .moodPopover .popRow .moodButtonContent .moodName {
    font-size: 10px;
  }
}

ion-button {
  --background: transparent;
  --background-activated: transparent;
}

.action-point-button {
  filter: drop-shadow(1px 1px 1px #888888);
  position: absolute;
  right: 15px;
  bottom: 4rem;
  cursor: pointer;
  z-index: 999;
}

.location-modal-button {
  filter: drop-shadow(1px 1px 1px #888888);
  position: absolute;
  right: 15px;
  bottom: calc(4rem + 60px);
  cursor: pointer;
  z-index: 999;
}

.action-point-button:hover {
  background: none;
}

.action-point-icon {
  width: 25px;
  height: 25px;
}

.close-gallery-container {
  position: absolute;
  top: calc(20px + env(safe-area-inset-top));
  right: 20px;
  cursor: pointer;
  height: auto;
  filter: drop-shadow(1px 1px 2px rgba(37, 37, 37, 0.3));
}

.close-gallery {
  box-shadow: 0 0 0 #888;
}

.top-row-modal {
  background-color: var(--planeed-color-white);
  height: 40px;
}

.modal-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center center;
}

.swiper-button-prev,
.swiper-button-next {
  color: white;
  width: 44px;
  height: 44px;
  z-index: 10;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: block;
  filter: drop-shadow(1px 1px 1px #888888);
}
.swiper-button-prev::after,
.swiper-button-next::after {
  font-size: 24px;
  font-weight: bold;
}

.swiper-button-prev {
  left: 10px; /* oder left: 0 + translateX */
}

.swiper-button-next {
  right: 0;
  transform: translate(50%, -50%);
}

.profile-row {
  height: fit-content;
  display: flex;
  align-items: center;
}

.created-by {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}

.profile-wrapper {
  padding-left: 20px;
  padding-bottom: 0;
}

.moods-count {
  padding-right: 5px;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 21px;
  text-shadow: 1px 1px 1px #888888;
}

.single-image-wrapper img {
  object-fit: cover;
}

.popOverMenuButton {
  position: absolute;
  cursor: pointer;
  height: 17px;
  --padding-end: 0px;
  --padding-start: 0px;
  z-index: 99;
}

.popOverMenubuttonPosModal {
  top: calc(10px + env(safe-area-inset-top));
  right: 50px;
}

.popOverMenubuttonPosPage {
  top: calc(20px + env(safe-area-inset-top));
  right: 20px;
}

.trippleDotMenuButton {
  font-size: 17px;
  text-shadow: 1px 1px 1px #888888;
  z-index: 99;
}

ion-item {
  --padding-start: 0px !important;
  --padding-end: 0px !important;
  --inner-padding-start: 0px !important;
  --inner-padding-end: 0px !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
